module.exports = __webpack_public_path__ + "static/media/spei.e7d7e6af.svg";